import { matchRoutes, useLocation } from 'react-router-dom'
import { arrayOfRoutes, Locations } from 'shared/Router/Locations'

export default function useCurrentPath() {
  const location = useLocation()
  const route = matchRoutes(arrayOfRoutes(Locations), location)

  return route ? route[0].route.path : null
}
